import { defineSlotRecipe } from '@chakra-ui/react';

export const sortingSelectSlotRecipe = defineSlotRecipe({
    slots: ['sorting'],
    base: {
        sorting: {
            flex: '0 0 298px',
            display: {
                base: 'none',
                md: 'block',
            },
        },
    },
});
